<template>
  <div class="space-y-4">
    <div class="section-description" v-if="!isPreview">
      <add-element-button
        :addElBtnCustomRef="`add-btn-modal-${index}-section-description`"
        :getThemeSettings="getThemeSettings"
        :callback="updateDescription"
        :html="content.description"
      ></add-element-button>
    </div>
    <div class="section-description" v-else v-html="content.description"></div>
    <div class="video-iframe-wrapper relative" :class="checkVideoWidget?'groovevideo-iframe-wrapper-class ':'groovevideo-custom-class-2'">
      <div v-if="videoEmbed" v-html="videoEmbed"></div>
      <div v-else-if="playableSource">
        <iframe
          class="ql-video"
          :src="playableSource"
          autoplay="false"
          allowfullscreen="true"
          frameborder="0"
        ></iframe>
      </div>
      <div
        v-else
        class="
          flex
          items-center
          justify-center
          mt-4
          h-20
          border
          bg-grey-100
          pointer-events-none
        "
      >
        <span> No Video !! </span>
      </div>
      <video-picker
        v-if="!isPreview"
        :value="{ videoSrc, videoEmbed }"
        @selected="updateVideoAttributes"
      ></video-picker>
    </div>
    <div class="section-paragraph" v-if="!isPreview">
      <add-element-button
        :addElBtnCustomRef="`add-btn-modal-${index}-section-paragraph`"
        :getThemeSettings="getThemeSettings"
        :callback="updateContent"
        :html="content.html"
      ></add-element-button>
    </div>
    <div class="section-paragraph" v-else v-html="content.html"></div>
  </div>
</template>
<script>
import parseVideoHelper from '@groovepages/gd-ui-kit/components/video-library/helpers/parseVideo';
import VideoPicker from '@groovepages/gd-ui-kit/components/video-library/VideoLibrary';
import AddElementButton from '../button/add-element';
import quillMixin from '../../../mixins/quill';

export default {
  name: 'Video',
  mixins: [quillMixin],
  props: {
    isPreview: {
      type: Boolean,
      default: true,
    },
    index: {},
    getThemeSettings: {},
    content: {
      type: Object,
      required: true,
    },
  },
  components: {
    AddElementButton,
    VideoPicker,
  },
  data() {
    return {
      youtubeUrl: 'https://www.youtube.com/embed/',
      vimeoUrl: 'https://player.vimeo.com/video/',
      grooveVideoUrl: 'https://app.groove.cm/groovevideo/video',
    };
  },
  methods: {
    updateDescription(contentString) {
      this.$emit('updateSectionContent', {
        ...this.content,
        description: contentString,
      });
    },
    updateContent(contentString) {
      this.$emit('updateSectionContent', {
        ...this.content,
        html: contentString,
      });
    },
    updateVideoAttributes(video) {
      if (!video.video_embed) return;

      this.$emit('updateSectionContent', {
        ...this.content,
        embed: video.video_embed,
        link: video.video_source,
      });
    },
  },
  computed: {
    videoEmbed() {
      return this.content.embed;
    },
    videoSrc() {
      return this.content.link;
    },
    playableSource() {
      const { id, type } = parseVideoHelper(this.videoSrc);
      if (type === 'youtube') {
        return this.youtubeUrl + id;
      }

      if (type === 'vimeo') {
        return this.vimeoUrl + id;
      }

      return this.videoSrc;
    },
    checkVideoWidget() {
      if(this.content && this.content.embed){
        return this.content.embed.includes('groovevideo-widget')
      }
    }
  },
};
</script>
<style lang="scss">
.groovevideo-iframe-wrapper-class {
    height: auto !important;    
    padding-bottom: 0 !important;
}

.groovevideo-iframe-wrapper-class [class^='groovevideo-widget-outer-'] {
    max-height: inherit !important;
}
.video-iframe-wrapper {
  .video-iframe-edit {
    position: absolute;
    height: 100%;
    top: 0;
    right: -40px;
    padding-left: 10px;
    //display: none;
    svg {
      display: none;
    }
  }
  &:hover {
    .video-iframe-edit {
      svg {
        display: block;
      }
    }
  }
}
</style>
